/**
 * Comprueba si un objeto contiene una propiedad
 *
 * @param {Object} - Objecto que queremos comprobar
 * @param {String} - Propiedad que queremos buscar
 * @return {Boolean} - Devuelve si la propiedad existe o no
 */
const hasProp = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);

export {
  hasProp,
};
